import styled from "styled-components";

// Same loader container as menu page
export const LoaderContainer = styled.div(({ theme }) => ({
    width: "100vw",
    height: "100vh",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    background: theme.colors[theme.colorMode].canvas_Primary,
}));
